import { IdBuilder } from './../ts/rlAdmin.utils';
import { ContractService } from './contract-service';
import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";
import { CharTypeIDs } from "../ts/rlAdmin.consts";
import { EntityService } from './entity-service';
import * as Consts from "../ts/rlAdmin.consts";

export class RightService extends RLBaseService {

    static $inject = ["$resource", "entityService", "contractService"];
    public catalogTitleDictionary: { [key: number]: string } = {};
    public contactTitlesDictionary: { [key: number]: string } = {};
    public rightSetCatalogTitlesDictionary: { [key: string]: Models.IKeyValuePair<number, string>[] } = {};
    public rightSetContactTitlesDictionary: { [key: string]: Models.IKeyValuePair<number, string>[] } = {};

    constructor(
        private $resource: ng.resource.IResourceService,
        private entityService: EntityService,
        private contractService: ContractService,
    ) {
        super($resource);
    }

    getAssetAvailableRights(entityID: string) {
        return this.toRLService<Models.IPropertyAvailability2>("/api/right/getassetavailablerights/").query({ entityID: entityID }).$promise;
    }

    public searchRights(parentEntityId: string, groupByMethod: string, groupId: number, rowCount: number,
        startDate: string, endDate: string, titleKeywords: string, filters: _.Dictionary<string[]>,
        facetFields: string[], sortDir: number, sortField: string, selectedPaths: { [label: string]: string[] }): ng.IPromise<Models.ISearchCatalogRightsResponse | Models.IGetContractRightsResponse> {
        let split = IdBuilder.splitEntityID(parentEntityId);
        if (split.charTypeID === CharTypeIDs.property) {
            return this.entityService.searchCatalogRights(
                split.recID, startDate, endDate, titleKeywords, filters,
                facetFields, 1, rowCount, sortDir, sortField, groupByMethod, groupId, selectedPaths);
        } else if (split.charTypeID === CharTypeIDs.transaction) {
            return this.contractService.getContractRights(
                split.recID, startDate, endDate, titleKeywords, filters,
                facetFields, 1, rowCount,sortDir, sortField, groupByMethod, groupId, selectedPaths);
        } else {
            throw new Error("Can only search for rights with a deal or asset parent. ");
        }
    }

    public getContractAssetTitles(contractId: number, getImplicitCatalogItems: boolean = false): ng.IPromise<{ [key: number]: string }> {
        return this.contractService.getContractAssetTitles(contractId, getImplicitCatalogItems).then(contractAssetResult => {
            this.catalogTitleDictionary = contractAssetResult.data;
            return this.catalogTitleDictionary;
        })
    };

    public getRightSetCatalogTitlesDictionary(rightSets: (Models.IContractRightDocumentRelationshipPair | Models.IPropertyRightsetDocumentRelationshipPair)[], contractId: number, getImplicitCatalogItems: boolean = false) {
        return this.getContractAssetTitles(contractId, getImplicitCatalogItems).then(catalogTitleDictionary => {
            rightSets.forEach((rightSet: Models.IContractRightDocumentRelationshipPair) => {
                var rightsAssetRels = rightSet.assetRels;
                var rightAssetTitles: Models.IKeyValuePair<number, string>[] = [];
                _.forEach(rightsAssetRels, rightAssetRel => {
                    if (catalogTitleDictionary[rightAssetRel.childRecID]) {
                        var rightSetAssetTitlePair: Models.IKeyValuePair<number, string> = {
                            key: rightAssetRel.childRecID,
                            value: catalogTitleDictionary[rightAssetRel.childRecID]
                        };
                        rightAssetTitles.push(rightSetAssetTitlePair);
                    }
                });

                this.rightSetCatalogTitlesDictionary[rightSet.document.entityID] = rightAssetTitles;
            });
            return this.rightSetCatalogTitlesDictionary;
        })
    }

    public getRightSetContactTitlesDictionary(rightSets: (Models.IContractRightDocumentRelationshipPair | Models.IPropertyRightsetDocumentRelationshipPair)[]) {
        this.contactTitlesDictionary = {};
        let contactRecIds = []
        rightSets.forEach(right => {
            right.contactRels.forEach(contactRel => {
                contactRecIds.push(contactRel.childRecID);
            });
        });
        let request: Models.ISearchResultByRecordIDsRequest = {
            charTypeID: Consts.CharTypeIDs.user,
            recordIDs: contactRecIds.join(","),
            rowCount: contactRecIds.length
        };
        return this.entityService.getRecordDocumentsForRecordIDs(request)
            .then((result) => {
                _.forEach(result.documents, (recordDocument) => {
                    this.contactTitlesDictionary[recordDocument.recordID] = recordDocument.title;
                });
                _.forEach(rightSets, (rightset: Models.IContractRightDocumentRelationshipPair) => {
                    var rightsContactRels = rightset.contactRels;
                    var rightContactTitles: Models.IKeyValuePair<number, string>[] = [];
                    _.forEach(rightsContactRels, rightsContactRel => {
                        if (this.contactTitlesDictionary[rightsContactRel.childRecID]) {
                            var rightSetContactTitlePair: Models.IKeyValuePair<number, string> = {
                                key: rightsContactRel.childRecID,
                                value: this.contactTitlesDictionary[rightsContactRel.childRecID]
                            };
                            rightContactTitles.push(rightSetContactTitlePair);
                        }
                    });
                    this.rightSetContactTitlesDictionary[rightset.document.entityID] = rightContactTitles;
                });
                return this.rightSetContactTitlesDictionary;
            })
            .finally(() => {
            });
    }
}